import { useState, useEffect, useRef } from 'react';
import userAvtar from '../../assets/images/users/avatar-1.jpg';
import { logout } from '../../utils/auth';
import logo from '../../assets/images/logo.png'

const Header = () => {
	const logOutClick = () => {
		if (window.confirm("Are you sure you want to log out?")) {
			logout();
		}
	};

	return (
		<nav className="hk-navbar navbar navbar-expand-xl navbar-light fixed-top">
			<div className="container-fluid">
				<div className="nav-start-wrap">
					<button className="btn btn-icon btn-rounded btn-flush-dark flush-soft-hover navbar-toggle d-xl-none">
						<span className="icon">
							<i className="ri-menu-line ri-lg"></i>
						</span>
					</button>
				</div>
				<div className="nav-end-wrap">
					<ul className="navbar-nav flex-row">

						<li className="nav-item">
							<div className="dropdown dropdown-notifications">
								<a href="#" className="btn btn-icon btn-rounded btn-flush-dark flush-soft-hover dropdown-toggle no-caret" data-bs-toggle="dropdown" data-dropdown-animation role="button" aria-haspopup="true" aria-expanded="false">
									<span className="icon">
										<span className="position-relative">
											<span className="feather-icon"><i className="ri-notification-3-line ri-lg"></i></span>
											<span className="badge badge-success badge-indicator position-top-end-overflow-1"></span>
										</span>
									</span>
								</a>
								<div className="dropdown-menu dropdown-menu-end p-0">
									<h6 className="dropdown-header px-4 fs-6">Notifications<a href="#" className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover"><span className="icon"><span className="feather-icon"><i data-feather="settings"></i></span></span></a>
									</h6>
									<div data-simplebar className="dropdown-body  p-2">
										<a href="javascript:void(0);" className="dropdown-item">
											<div className="media">
												<div className="media-head">
													<div className="avatar avatar-rounded avatar-sm">
														<img src="/dist/img/avatar2.jpg" alt="user" className="avatar-img" />
													</div>
												</div>
												<div className="media-body">
													<div>
														<div className="notifications-text">Morgan Freeman accepted your invitation to join the team</div>
														<div className="notifications-info">
															<span className="badge badge-soft-success">Collaboration</span>
															<div className="notifications-time">Today, 10:14 PM</div>
														</div>
													</div>
												</div>
											</div>
										</a>
										<a href="javascript:void(0);" className="dropdown-item">
											<div className="media">
												<div className="media-head">
													<div className="avatar  avatar-icon avatar-sm avatar-success avatar-rounded">
														<span className="initial-wrap">
															<span className="feather-icon"><i data-feather="inbox"></i></span>
														</span>
													</div>
												</div>
												<div className="media-body">
													<div>
														<div className="notifications-text">New message received from Alan Rickman</div>
														<div className="notifications-info">
															<div className="notifications-time">Today, 7:51 AM</div>
														</div>
													</div>
												</div>
											</div>
										</a>
										<a href="javascript:void(0);" className="dropdown-item">
											<div className="media">
												<div className="media-head">
													<div className="avatar  avatar-icon avatar-sm avatar-pink avatar-rounded">
														<span className="initial-wrap">
															<span className="feather-icon"><i data-feather="clock"></i></span>
														</span>
													</div>
												</div>
												<div className="media-body">
													<div>
														<div className="notifications-text">You have a follow up with Jampack Head on Friday, Dec 19 at 9:30 am</div>
														<div className="notifications-info">
															<div className="notifications-time">Yesterday, 9:25 PM</div>
														</div>
													</div>
												</div>
											</div>
										</a>
										<a href="javascript:void(0);" className="dropdown-item">
											<div className="media">
												<div className="media-head">
													<div className="avatar avatar-sm avatar-rounded">
														<img src="/dist/img/avatar3.jpg" alt="user" className="avatar-img" />
													</div>
												</div>
												<div className="media-body">
													<div>
														<div className="notifications-text">Application of Sarah Williams is waiting for your approval</div>
														<div className="notifications-info">
															<div className="notifications-time">Today 10:14 PM</div>
														</div>
													</div>
												</div>
											</div>
										</a>
										<a href="javascript:void(0);" className="dropdown-item">
											<div className="media">
												<div className="media-head">
													<div className="avatar avatar-sm avatar-rounded">
														<img src="/dist/img/avatar10.jpg" alt="user" className="avatar-img" />
													</div>
												</div>
												<div className="media-body">
													<div>
														<div className="notifications-text">Winston Churchil shared a document with you</div>
														<div className="notifications-info">
															<span className="badge badge-soft-violet">File Manager</span>
															<div className="notifications-time">2 Oct, 2021</div>
														</div>
													</div>
												</div>
											</div>
										</a>
										<a href="javascript:void(0);" className="dropdown-item">
											<div className="media">
												<div className="media-head">
													<div className="avatar  avatar-icon avatar-sm avatar-danger avatar-rounded">
														<span className="initial-wrap">
															<span className="feather-icon"><i data-feather="calendar"></i></span>
														</span>
													</div>
												</div>
												<div className="media-body">
													<div>
														<div className="notifications-text">Last 2 days left for the project to be completed</div>
														<div className="notifications-info">
															<span className="badge badge-soft-orange">Updates</span>
															<div className="notifications-time">14 Sep, 2021</div>
														</div>
													</div>
												</div>
											</div>
										</a>
									</div>
									<div className="dropdown-footer"><a href="#"><u>View all notifications</u></a></div>
								</div>
							</div>
						</li>
						<li className="nav-item">
							<div className="dropdown ps-2">
								<a className=" dropdown-toggle no-caret" href="#" role="button" data-bs-display="static" data-bs-toggle="dropdown" data-dropdown-animation data-bs-auto-close="outside" aria-expanded="false">
									<div className="avatar avatar-rounded avatar-xs">
										<img src="/dist/img/avatar12.jpg" alt="user" className="avatar-img" />
									</div>
								</a>
								<div className="dropdown-menu dropdown-menu-end">
									<div className="p-2">
										<div className="media">
											<div className="media-head me-2">
												<div className="avatar avatar-primary avatar-sm avatar-rounded">
													<span className="initial-wrap">Hk</span>
												</div>
											</div>
											<div className="media-body">
												<a href="#" className="d-block link-dark fw-bold">Hencework</a>
												<div className="fs-7">contact@hencework.com</div>
											</div>
										</div>
									</div>
									<div className="dropdown-divider"></div>

									<a className="dropdown-item" href="#"><span className="dropdown-icon feather-icon"><i data-feather="credit-card"></i></span><span>Payment methods</span></a>
									<a className="dropdown-item" href="#"><span className="dropdown-icon feather-icon"><i data-feather="check-square"></i></span><span>Subscriptions</span></a>
									<a className="dropdown-item" href="#"><span className="dropdown-icon feather-icon"><i data-feather="settings"></i></span><span>Settings</span></a>
									<div className="dropdown-divider"></div>
									<a className="dropdown-item" href="#" onClick={logOutClick}>
										<span className="dropdown-icon"><i className="ri-logout-box-r-line"></i></span>
										<span>Logout</span>
									</a>

								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</nav>

	);
};

export default Header;



